export default __webpack_public_path__ + "static/media/pilgrims.248814c0.svg";